import React from 'react';
import {
	Alert,
	AlertTitle,
	Breadcrumbs,
	Button,
	IconButton,
	Link,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	TextField,
	Tooltip,
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import { useSelector, useDispatch } from 'react-redux';
import {
	createFolder,
	deleteFolder,
	deleteSingleDocument,
	getFolder,
	getParentFolder,
	getSubFolder,
	uploadFile,
} from '../../../actions/files';
import { useEffect, useState } from 'react';
import {
	handleError,
	handleInfo,
	handleWarning,
	highPermissions,
	rowStyle,
} from '../../../helpers/utils';
import Swal from 'sweetalert2';

// Button styles
const iconButtonStyle = { color: '#143f6c' };
const itemIconButton = { width: '50%', margin: '0 auto' };

// Users excluded from private folders ('Empaque' and 'Alta de cliente')
const warehouseExcludedUsers = [
	'marcomorales@piluniformes.com.mx',
	'almacen@piluniformes.com.mx',
	'empaque@piluniformes.com.mx',
];

// Sort of excluded folders
const excludedFolders = ['ALTA_CLIENTE', 'EMPAQUE'];

const excludedPermission = (user, folderName) => {
	return (
		warehouseExcludedUsers.includes(user?.email) &&
		excludedFolders.includes(folderName)
	);
};

export const WorkspaceNew = ({ repo = null, idOrder = null }) => {
	const { folders, currentPath } = useSelector((state) => state.files);
	const { uid } = useSelector((state) => state.auth);
	const { user } = useSelector((state) => state);
	const dispatch = useDispatch();
	let path = repo
		? `users/${uid}/digitalRepository`
		: `orders/${idOrder}/folders`;
	const initialPath = [{ name: 'Archivos', url: path, order: Date.now() }];
	const [lastPaths, setLastPaths] = useState(initialPath);

	const [showTextFieldFolderName, setShowTextFieldFolderName] =
		useState(false);
	const [folderName, setFolderName] = useState('');

	const handleChangePath = (folder, completePath = null, order) => {
		if (completePath) {
			const updatedPaths = lastPaths.filter(
				(lastPath) => lastPath.order <= order
			);
			setLastPaths(updatedPaths);
			path = completePath;
		} else {
			path = `${lastPaths[lastPaths.length - 1].url}/${folder.uid}/${
				repo ? 'digitalRepository' : 'folders'
			}`;
			const newPath = {
				name: folder.name,
				url: path,
				order: folder.order,
			};
			setLastPaths([...lastPaths, newPath]);
		}
		if (path === initialPath[0].url) {
			setLastPaths(initialPath);
		}
		console.log(lastPaths);
		dispatch(getFolder(path));
	};

	const handleCreateFolder = () => {
		dispatch(createFolder(folderName, currentPath));
		setShowTextFieldFolderName(false);
		setFolderName('');
	};

	const handleDeleteFolder = (folderPath = null) => {
		Swal.fire({
			icon: 'warning',
			title: 'Eliminar carpeta',
			text: '¿Está seguro que desea eliminar esta carpeta junto con todo su contenido?',
			showCancelButton: true,
			confirmButtonColor: '#084f93',
			cancelButtonColor: '#d33',
			cancelButtonText: 'Cancelar',
			confirmButtonText: 'Está bien',
		}).then(({ isConfirmed }) => {
			if (isConfirmed) {
				let tempPath = folderPath
					? folderPath
					: lastPaths[lastPaths.length - 1].url;
				console.log(tempPath);
				const tmpParentFolder =
					getParentFolder(tempPath, 2) + '/folders';
				console.log('parentFolder: ', tmpParentFolder);
				lastPaths.pop();
				getSubFolder(tempPath)
					.then((docs) => {
						if (docs.length > 0) {
							// Delete folder with subfolders
							deleteFolder(docs, 0, tempPath);
							console.log(docs);
						} else {
							// Delete single document
							deleteSingleDocument(getParentFolder(tempPath));
						}
						handleChangePath(null, tmpParentFolder, Date.now());
						setTimeout(() => {
							dispatch(getFolder(path));
						}, 1000);
					})
					.catch((error) => {
						console.log(
							'Error get subfolder for delete preparation. ',
							error
						);
						Swal.fire({
							icon: 'error',
							title: 'Carpeta grande',
							text: 'Esta carpeta tiene muchos subfolders, selecciona una con menor de carpetas a borrar.',
							showCancelButton: false,
							confirmButtonColor: '#084f93',
							cancelButtonColor: '#d33',
							confirmButtonText: 'Está bien',
						});
					});
			}
		});
	};

	// Upload file
	const handleFileChange = (e) => {
		const file = e.target.files[0];

		if (file) {
			try {
				console.log('Uploading file to storage consult');
				handleInfo('Cargando...');
				const typePath = repo ? 'repo' : 'fileConsult';
				dispatch(
					uploadFile(file, typePath, file.name, repo ? null : idOrder)
				);
			} catch (error) {
				console.log(error);
				handleError(
					error,
					'Ocurrió un error al intentar cargar el archivo'
				);
			}
		} else {
			handleWarning('El archivo que no es válido');
		}
	};

	const handleDeleteFile = (sub) => {
		const deletePath = `${sub.path}/${sub.uid}`;
		deleteSingleDocument(deletePath);
	};

	useEffect(() => {
		console.log('Getting folder with path: ', path);
		dispatch(getFolder(path));
	}, [dispatch, path]);

	const FolderItem = ({ sub }) => (
		<ListItem key={sub.uid}>
			<ListItemIcon>
				{sub.isFile ? (
					<FilePresentIcon color='#084f93' />
				) : (
					<FolderIcon color='#084f93' />
				)}
			</ListItemIcon>
			<ListItemText
				style={{
					cursor: sub.isFile ? '' : 'pointer',
				}}
				primary={sub.name}
				secondary={new Date(sub.created.seconds * 1000).toLocaleString(
					'mx'
				)} // change for "updated"
			/>
			{sub.isFile ? (
				<>
					<a href={sub.url} target='_blank' rel='noreferrer'>
						Ver archivo
					</a>
					<span
						onClick={() => {
							handleDeleteFile(sub);
						}}
						style={{
							marginLeft: '10px',
							color: 'red',
							textDecoration: 'underline',
							cursor: 'pointer',
						}}
					>
						Eliminar
					</span>
				</>
			) : (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						width: 'auto',
					}}
				>
					<div style={itemIconButton}>
						<Tooltip title='Ver' placement='left-end'>
							<IconButton
								style={iconButtonStyle}
								aria-label='profile'
								color='primary'
								onClick={() => {
									if (!sub.isFile) {
										handleChangePath({
											name: sub.name,
											uid: sub.uid,
											url: sub.path,
											order: Date.now(),
										});
									}
								}}
							>
								<InfoIcon />
							</IconButton>
						</Tooltip>
					</div>
					<div style={itemIconButton}>
						<Tooltip title='Eliminar' placement='left-end'>
							<IconButton
								style={iconButtonStyle}
								aria-label='delete'
								color='primary'
								onClick={() => {
									// Delete folder
									handleDeleteFolder(
										`${sub.path}/${sub.uid}/folders`
									);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</div>
				</div>
			)}
		</ListItem>
	);

	return (
		<div
			style={{
				borderRadius: '17px',
				width: '100%',
			}}
		>
			<h2>Almacén digital</h2>
			<div
				style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignContent: 'flex-start',
					margin: '25px 0',
				}}
			>
				<div
					style={{
						display: 'flex',
						...rowStyle,
						alignContent: 'flex-start',
						marginBottom: '15px',
						width: '50%',
						justifyContent: 'space-around',
					}}
				>
					<Button
						variant='outlined'
						color='primary'
						onClick={() => {
							setShowTextFieldFolderName(true);
						}}
					>
						Nueva carpeta
						<CreateNewFolderIcon style={{ margin: '0 0 0 10px' }} />
					</Button>

					<Button
						variant='outlined'
						color='primary'
						onClick={handleDeleteFolder}
					>
						Eliminar carpeta
						<FolderDeleteIcon style={{ margin: '0 0 0 10px' }} />
					</Button>

					<Button
						variant='outlined'
						component='label'
						color='primary'
					>
						Subir archivo
						<UploadFileIcon style={{ margin: '0 0 0 10px' }} />
						<input
							type='file'
							hidden
							id='inputFileCV'
							onChange={handleFileChange}
						/>
					</Button>
				</div>

				{showTextFieldFolderName && (
					<div style={{ width: '15%', margin: '15px 0 15px 20px' }}>
						<TextField
							value={folderName}
							placeholder='Nombre de la carpeta'
							onChange={({ target }) =>
								setFolderName(target.value)
							}
							variant='standard'
							onKeyDown={({ key }) => {
								if (key === 'Enter') {
									handleCreateFolder();
								}
							}}
						/>
						<Button
							size='small'
							color='error'
							onClick={() => {
								setFolderName('');
								setShowTextFieldFolderName(false);
							}}
						>
							Cancelar
						</Button>
						<Button
							color='primary'
							size='small'
							onClick={handleCreateFolder}
						>
							Crear
						</Button>
					</div>
				)}

				<Breadcrumbs
					aria-label='breadcrumb'
					style={{ marginLeft: '20px' }}
				>
					{lastPaths.map((item) => (
						<Link
							key={item.name}
							underline='hover'
							color='inherit'
							onClick={() =>
								handleChangePath(null, item.url, item.order)
							}
						>
							{item.name}
						</Link>
					))}
				</Breadcrumbs>

				{folders.length > 0 ? (
					<div style={{ margin: '0 15px' }}>
						<List dense={true}>
							{/* List subfolders (if any) */}
							{folders.map((sub, i) => {
								if (sub.isPrivate) {
									if (
										highPermissions(user) || // Admin access
										excludedPermission(user, sub.name) // Special granted access
									) {
										return (
											<FolderItem
												key={`folder-${i}`}
												sub={sub}
											/>
										);
									}
									return null;
								}
								return (
									<FolderItem key={`folder-${i}`} sub={sub} />
								);
							})}
						</List>
					</div>
				) : (
					<div style={{ margin: '0 15px' }}>
						<Alert severity='info' sx={{ mt: 3 }}>
							<AlertTitle>Carpeta vacía</AlertTitle>
						</Alert>
					</div>
				)}
			</div>
		</div>
	);
};
